import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const SelectExcludeIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M22 6.25H17.75V2C17.75 1.5859 17.4141 1.25 17 1.25H2C1.5859 1.25 1.25 1.5859 1.25 2V17C1.25 17.4141 1.5859 17.75 2 17.75H6.25V22C6.25 22.4141 6.5859 22.75 7 22.75H22C22.4141 22.75 22.75 22.4141 22.75 22V7C22.75 6.5859 22.4141 6.25 22 6.25ZM7.75 7.75H16.25V16.25H7.75V7.75Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

SelectExcludeIcon.displayName = 'SelectExcludeIcon';
